import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'

function EmailField(props) {
  const [field, setField] = useState('')
  const [field_touched, setFieldTouched] = useState(false)

  const validate = (e) => {
    e.preventDefault()

    const elem = document.getElementById(props.id)

    if (elem.value && /[\w]+[@][\w]+[.][\w]+/.test(elem.value)) {
      setField(elem.value)
      props.setField(elem.value)
    } else {
      setField(undefined)
      props.setField(undefined)
    }
  }

  return (
    <Col xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
      <Form.Group>
        <Form.Label>{props.label}</Form.Label>
        <Form.Control
          id={props.id}
          type="email"
          placeholder=""
          maxLength="50"
          onInput={validate}
          onBlur={() => setFieldTouched(true)}
          isInvalid={field_touched && !field}
        />
        <Form.Control.Feedback type="invalid">
          {props.invalid_message}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

EmailField.propTypes = {
  id: PropTypes.string.isRequired,
  invalid_message: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lg: PropTypes.number,
  md: PropTypes.number,
  setField: PropTypes.func.isRequired,
  sm: PropTypes.number,
  xl: PropTypes.number,
  xs: PropTypes.number
}

export default EmailField
